import React, { useState, useEffect } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import axios from 'axios';
import { AiOutlineEdit } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Row, Col, Table } from "react-bootstrap";
import Select from 'react-select';
import { FaRegEye } from "react-icons/fa";
import socket from "../../../socket";
import { FaLaptop } from "react-icons/fa";
import { LiaEdit } from "react-icons/lia";
import { BsPersonCheck } from "react-icons/bs";
import { GrStatusGood } from "react-icons/gr";

const MyApplications = () => {
    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const [applyList, setApplyList] = useState([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showMake, setShowMake] = useState(false);
    const [selectedEmp, setSelectedEmp] = useState(null);
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };

    const [isViewMode, setIsViewMode] = useState(false);
    const [showInterviewModal, setShowInterviewModal] = useState(false);
    const [user, setUser] = useState([]);
    const [interviews, setInterviews] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editSubjectId, setEditSubjectId] = useState(null);
const [statusFilter, setStatusFilter] = useState("");

    const [form, setForm] = useState({
        title: '',
        first: '',
        middle: '',
        last: "",
        emp_id: "",
        emp_code: '',
        phone: '',
        extension: '',
        email: '',
        dob: '',
        confirmed: '',
        gender: '',
        job_status: '',
        designation: '',
        department: '',
        address: '',
        city: '',
        pin: '',
        state: '',
        bank_name: '',
        bank_acc: '',
        bank_branch: '',
        ifsc: '',
        esic: '',
        reporting: '',
        weekly_off: '',
        basic: '',
        marital_status: '',
        doj: '',
        seperation_date: '',
        pf_no: '',
        alt_first: '',
        alt_second: '',
        region: '',
        lic: "",
        mediclaim_no: '',
        role: '',
        branch: '',

        medical_info: '',
        medical_condition: '',
        blood_grp: '',
        alergies: '',
        phoneChecked: false,
        phoneChecked_one: false,
        phoneChecked_two: false,
        pincode_two: '',
        state_two: '',
        city_two: '',
        region_two: '',
        address_two: '',


    });

    const [showForm, setShowForm] = useState(false);

    const [interviewForm, setInterviewForm] = useState({
        candidate_id: "",
        interviewer: "",
        step: "Step 1",
        status: "Pending",
        marks: "",
        remarks: ""
    });

    // dropdown data
    const [employees, setEmployees] = useState([]); // fill from API
    const [statusOptions, setStatusOptions] = useState([
        "Pending",
        "Shortlisted",
        "Rejected"
    ]);


    const titleOptions = [
        { value: '1', label: 'Mrs.' },
        { value: '2', label: 'Mr.' },
        { value: '3', label: 'Ms.' },
    ]

    const [rows, setRows] = useState([
        {
            employer: "",
            designation: "",
            doj: "",
            leftOn: "",
            joiningSalary: "",
            lastSalary: "",
        },
    ]);

    const [educationRows, setEducationRows] = useState([
        {
            exam: "",
            board: "",
            passingYear: "",
            percentage: "",
            certificate: null,
        },
    ]);

    const genderOptions = [
        { value: '1', label: 'Male' },
        { value: '2', label: 'Female' },
        { value: '3', label: 'Other' }
    ]

    const [members, setMembers] = useState([
        { name: "", relation: "", contact: "", work: "" },
    ]);

    const [files, setFiles] = useState({
        file: null,
        pan: null,
        aadhaar: null,
        light_bill: null,
        tenth_mark: null,
        twelth_mark: null,
        other_doc: null

    });


    useEffect(() => {

        socket.on("new-application", (data) => {

            setApplyList(prev => [
                ...prev,
                data
            ]);

            showToast(data.message, "info");
        });

        return () => {
            socket.off("new-application");
        };

    }, []);

    const fileFields = [
        "file",
        "pan",
        "aadhaar",
        "light_bill",
        "tenth_mark",
        "twelth_mark",
        "other_doc"
    ];


    const handleChange = (e) => {
        const { name, value } = e.target;

        setInterviewForm({
            ...interviewForm,
            [name]: value
        });
    };

    const handleInterviewChange = (e) => {
        const { name, value } = e.target;
        setInterviewForm({ ...interviewForm, [name]: value });
    };


    const handleAddStatus = () => {
        const newStatus = prompt("Enter new status:");
        if (newStatus && !statusOptions.includes(newStatus)) {
            // Add to options
            setStatusOptions(prev => [...prev, newStatus]);

            // Immediately set it as selected
            setInterviewForm(prev => ({ ...prev, status: newStatus }));
        }
    };

    const fetchApplications = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-applications');
            setApplyList(res.data.result);
        } catch (error) {
            console.error("Error fetching Notices", error);
        } finally {
            setLoading(false);
        }
    }

    const fectEmphDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');

            const filteredEmployees = resEmployee.data.result.filter(emp =>
                emp.seperation_date == '' && emp.emp_id !== null
            );

            setUser(filteredEmployees);

        } catch (error) {
            console.log(error);
        }
    };

    const fetchInterView = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-interview');

            setInterviews(res.data);
            const data = res.data;

            const backendStatuses = data.map(item => item.status);
            setStatusOptions(prevStatusOptions => {
                const merged = [...new Set([...prevStatusOptions, ...backendStatuses])];
                return merged;
            });

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchApplications();
        fectEmphDetail();
        fetchInterView();
    }, [])

    const handleStatusChange = async (id, status) => {
    try {
        await axios.put("https://api.skyguard.group/api/update-application-status", {
            id,
            active_status: status,
        });

        // Update the table without refetching
        setApplyList((prev) =>
            prev.map((item) =>
                item.id === id
                    ? { ...item, active_status: status }
                    : item
            )
        );

        // OR simply reload the data
        // fetchApplications();

    } catch (error) {
        console.error("Error updating status:", error);
    }
};


    const handleRejectEmployee = async (id, status) => {

        try {
            const res = await axios.put(
                `https://api.skyguard.group/api/reject-employee/${id}`,
                {
                    status: status
                }
            );


            showToast('Application status updated!', 'success');
            // setTimeout(() => window.location.reload(), 2000);
            fetchApplications();

        } catch (err) {
            console.error(err.response?.data || err.message);
            showToast('Failed to update status!', 'danger');
        }
    };


    const handleConfirmEmployee = async (id, status) => {

        try {
            const res = await axios.put(
                `https://api.skyguard.group/api/confirm-employee/${id}`);

            console.log("Response:", res.data);
            showToast('Candidate Joining Confirmed!', 'success');
            fetchApplications();

        } catch (err) {
            console.error(err.response?.data || err.message);
            showToast('Failed to join employee!', 'danger');
        }
    };



    const handleView = (emp) => {

        setIsViewMode(true);
        setEditSubjectId(emp.id);
        setIsEditMode(true);

        setForm({
            id: emp.id,
            title: emp.title || '',
            first: emp.first || '',
            middle: emp.middle || '',
            last: emp.last || '',
            phone: emp.phone || '',
            email: emp.email || '',
            dob: emp.dob ? emp.dob.split('T')[0] : '',
            gender: emp.gender || '',
            role: emp.role || '',

            // Current address
            pin: emp.pin || '',
            state: emp.state || '',
            city: emp.city || '',
            region: emp.region || '',
            address: emp.address || '',

            // ✅ Permanent address (with fallback)
            pincode_two: emp.pincode_two || emp.pin || '',
            state_two: emp.state_two || emp.state || '',
            city_two: emp.city_two || emp.city || '',
            region_two: emp.region_two || emp.region || '',
            address_two: emp.address_two || emp.address || '',

            // ✅ Aadhaar
            aadhaar: emp.aadhaar || '',
        });

        // ✅ Employment History (JSON parse)
        try {
            let expData = [];

            if (emp.employment_history) {
                expData =
                    typeof emp.employment_history === "string"
                        ? JSON.parse(emp.employment_history)
                        : emp.employment_history;
            }

            setRows(expData);
        } catch (err) {
            console.error("Employment parse error:", err);
            setRows([]);
        }

        // ✅ Education History (JSON parse)
        try {
            let eduData = [];

            if (emp.education_details) {
                eduData =
                    typeof emp.education_details === "string"
                        ? JSON.parse(emp.education_details)
                        : emp.education_details;
            }

            setEducationRows(eduData);
        } catch (err) {
            console.error("Education parse error:", err);
            setEducationRows([]);
        }

        // ✅ Show form
        setShowForm(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
            ...(isEditMode && name === "phone" ? { phoneChecked: false } : {}),
            ...(isEditMode && name === "alt_first" ? { phoneChecked_one: false } : {}),
            ...(isEditMode && name === "alt_second" ? { phoneChecked_two: false } : {}),
        }));
    };

    const handleInterviewSubmit = async (data) => {
        try {
            if (isEditMode) {
                const res = await axios.put(`https://api.skyguard.group/api/update-schedule-interview/${interviewForm.id}`, interviewForm);

                showToast("Interview update!", "success");
            } else {

                const res = await axios.post("https://api.skyguard.group/api/add-schedule-interview", interviewForm);

                showToast("Interview Scheduled!", "success");
            }

            setShowInterviewModal(false);
            setIsEditMode(false);

            fetchInterView()

            // reset form
            setInterviewForm({
                candidate_id: "",
                candidate_name: "",
                interviewer: "",
                step: "Step 1",
                status: "Pending",
                marks: "",
                remarks: ""
            });

        } catch (error) {
            console.error(error);
            showToast("Something went wrong!", "danger");
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isEditMode) {
            const formData = new FormData();
            fileFields.forEach((key) => {
                if (files[key] instanceof File) {
                    formData.append(key, files[key]);
                }
            });

            Object.keys(form).forEach((key) => {

                if (key === "phoneChecked" || key === "phoneChecked_one" || key === 'phoneChecked_two') {
                    formData.append(key, form[key] ? 1 : 0);
                } else {
                    formData.append(key, form[key]);
                }
            });

            formData.append("employment_history", JSON.stringify(rows));
            formData.append(
                "education_details",
                JSON.stringify(
                    educationRows.map((e) => ({
                        ...e,
                        certificate: e.certificate ? e.certificate.name : null,
                    }))
                )
            );
            formData.append("family_members", JSON.stringify(members));


            try {
                const res = await axios.put(
                    `https://api.skyguard.group/api/update-employee/${editSubjectId}`,
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                showToast('Employee Updated successfully!', 'success');
                fetchApplications();
                setShowForm(false);
                setForm({
                    title: '', first: '', middle: '', last: '',
                    emp_id: '', emp_code: '', phone: '', extension: '',
                    email: '', dob: '', confirmed: '', gender: '', job_status: '',
                    designation: '', department: '', address: '', city: '',
                    pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
                    ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
                    marital_status: '', doj: '', seperation_date: '', pf_no: '',
                    role: '', region: '', alt_first: '', alt_second: '',
                    lic: '', mediclaim_no: '', branch: '', medical_info: '',
                    medical_condition: '',
                    blood_grp: '',
                    alergies: '',
                });

                setRows([]);
                setMembers([]);
                setEducationRows([]);

            } catch (err) {
                console.error(err.response?.data || err.message);
                showToast('Fail to updated Employee !', 'danger');
            }


        } else {


            const sendData = new FormData();

            sendData.append("title", form.title);
            sendData.append("first", form.first);
            sendData.append("middle", form.middle);
            sendData.append("last", form.last);
            // sendData.append("emp_id", form.emp_id);
            // sendData.append("emp_code", form.emp_code);
            sendData.append("phone", form.phone);
            sendData.append("extension", form.extension);

            sendData.append("email", form.email);
            sendData.append("dob", form.dob);
            sendData.append("confirmed", form.confirmed);
            sendData.append("gender", form.gender);
            sendData.append("job_status", form.job_status);
            sendData.append("designation", form.designation);
            sendData.append("department", form.department);
            sendData.append("address", form.address);
            sendData.append("city", form.city);
            sendData.append("pin", form.pin);
            sendData.append("state", form.state);
            sendData.append("bank_name", form.bank_name);
            sendData.append("bank_acc", form.bank_acc);
            sendData.append("bank_branch", form.bank_branch);
            sendData.append("ifsc", form.ifsc);
            sendData.append("esic", form.esic);
            sendData.append("reporting", form.reporting);
            sendData.append("weekly_off", form.weekly_off);
            sendData.append("basic", form.basic);
            sendData.append("marital_status", form.marital_status);
            sendData.append("doj", form.doj);
            sendData.append("seperation_date", form.seperation_date);
            sendData.append('pf_no', form.pf_no);

            sendData.append('alt_first', form.alt_first);
            sendData.append('alt_second', form.alt_second);
            sendData.append('region', form.region);
            sendData.append('lic', form.lic);
            sendData.append('mediclaim_no', form.mediclaim_no);
            sendData.append('role', form.role);
            sendData.append('branch', form.branch);
            sendData.append('medical_info', form.medical_info);
            sendData.append('medical_condition', form.medical_condition);
            sendData.append('blood_grp', form.blood_grp);
            sendData.append('alergies', form.alergies);
            sendData.append('phoneChecked', form.phoneChecked);
            sendData.append('phoneChecked_one', form.phoneChecked_one);
            sendData.append('phoneChecked_two', form.phoneChecked_two);

            sendData.append('pincode_two', form.pincode_two);
            sendData.append('state_two', form.state_two);
            sendData.append('city_two', form.city_two);
            sendData.append('region_two', form.region_two);
            sendData.append('address_two', form.address_two);

            Object.keys(files).forEach((key) => {
                if (files[key] instanceof File) {
                    sendData.append(key, files[key]);
                }
            });

            sendData.append("employment_history", JSON.stringify(rows));
            sendData.append("education_details", JSON.stringify(educationRows.map(e => ({
                ...e,
                certificate: e.certificate ? e.certificate.name : null
            }))));
            sendData.append("family_members", JSON.stringify(members));


            try {
                const res = await axios.post(
                    "https://api.skyguard.group/api/add-employee",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                setShowForm(false);
                showToast('Employee Added successfully!', 'success');
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
                showToast('Fail to added Employee  !', 'danger');
            }

        }
        fetchApplications();
        setShowForm(false);
        setIsEditMode(false);
        setForm({
            title: '', first: '', middle: '', last: '',
            emp_id: '', emp_code: '', phone: '', extension: '',
            email: '', dob: '', confirmed: '', gender: '', job_status: '',
            designation: '', department: '', address: '', city: '',
            pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
            ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
            marital_status: '', doj: '', seperation_date: '', pf_no: '',
            role: '', region: '', alt_first: '', alt_second: '',
            lic: '', mediclaim_no: '', branch: '', medical_info: '',
            medical_condition: '', blood_grp: '', alergies: '', pincode_two: '', state_two: '', city_two: '', region_two: '', address_two: '',
        });
        setFiles({});
        setRows([]);
        setMembers([]);
        setEducationRows([]);


    };

    const filteredApplications = applyList.filter((item) => {
    if (statusFilter === "") return true;
    return item.active_status === statusFilter;
});




    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                  <div className="d-flex justify-content-between align-items-center my-3">
    <h3 className="fw-bold fs-5 golos mb-0">
        Applications Received
    </h3>

    <select
        className="form-select"
        style={{ width: "150px" }}
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
    >
        <option value="">All</option>
        {/* <option value="yes">Active</option> */}
        <option value="no">Reject</option>
    </select>
</div>


                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />
                    {showForm && (
                        <div className='card p-3 mb-3' >
                            <form onSubmit={handleSubmit}  >
                                <h5 className="mt-1 fs-4 text-center fw-semibold text-primary">Basic Info</h5>
                                <hr />
                                <div className='row g-3'>
                                    {/* Title */}
                                    <div className="col-md-4">
                                        <label htmlFor="title" className="form-label fw-medium">Select Title</label>

                                        <Select
                                            options={titleOptions}
                                            placeholder="Choose Title..."
                                            id="title"
                                            value={titleOptions.find(option => option.label === form.title)}
                                            onChange={(selectedOption) =>
                                                setForm({ ...form, title: selectedOption.label })
                                            }
                                            isDisabled={isViewMode}
                                        />

                                    </div>
                                    {/* First Name */}
                                    <div className="col-md-4">
                                        <label htmlFor='name' className="form-label fw-medium" >First Name</label>
                                        <input type="text" className="form-control" name="first" placeholder="Enter here..." value={form.first} onChange={handleInputChange} required />
                                    </div>
                                    {/* Middle Name */}
                                    <div className="col-md-4">
                                        <label htmlFor='middle' className="form-label fw-medium" >Middle Name</label>
                                        <input type="text" className="form-control" name="middle" placeholder="Enter here..."
                                            value={form.middle}
                                            onChange={handleInputChange}

                                        />
                                    </div>
                                    {/* Last Name */}
                                    <div className="col-md-4">
                                        <label htmlFor='last' className="form-label fw-medium" >Last Name</label>
                                        <input type="text" className="form-control" name="last" placeholder="Enter here..."
                                            value={form.last}
                                            onChange={handleInputChange}
                                        />
                                    </div>



                                    <div className="col-md-4">
                                        <label htmlFor="phone" className="form-label fw-medium">Phone No.</label>

                                        {/* Phone input */}
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="phone"
                                            placeholder="Enter here..."
                                            value={form.phone}

                                            required
                                            maxLength={10}
                                            onChange={handleInputChange}
                                        />

                                    </div>



                                    {/* Email ID */}
                                    <div className="col-md-4">
                                        <label htmlFor='email' className="form-label fw-medium" >Email ID</label>
                                        <input type="text" className="form-control" name="email" placeholder="Enter here..." value={form.email} required onChange={handleInputChange} />
                                    </div>
                                    {/* DOB */}
                                    <div className="col-md-4">
                                        <label htmlFor="dob" className="form-label fw-medium">DOB</label>
                                        <input type="date" className="form-control" name="dob"
                                            value={form.dob}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    {/* Gender */}
                                    <div className="col-md-4">
                                        <label htmlFor="gender" className="form-label fw-medium">Select Gender</label>

                                        <Select
                                            options={genderOptions}
                                            placeholder="Choose Title..."
                                            id="title"
                                            value={genderOptions.find(option => option.label === form.gender)}
                                            onChange={(selectedOption) =>
                                                setForm({ ...form, gender: selectedOption.label })
                                            }
                                            isDisabled={isViewMode}
                                        />

                                    </div>


                                    <div className="col-md-4">
                                        <label htmlFor='role' className="form-label fw-medium" >Applying For</label>
                                        <input type="text" className="form-control" name="role" placeholder="Enter here..."
                                            value={form.role}

                                            disabled
                                            readOnly={isViewMode}
                                        />
                                    </div>


                                    <div className="mt-4">
                                        <h5 className='mt-1 fs-4 text-center fw-semibold text-primary'>Address Detail</h5>
                                        <hr />

                                        <div className="row">
                                            <h4 className='fw-semibold text-success'>Present Address</h4>
                                            <div className='col-md-4 '>



                                                <div className="d-flex align-items-end gap-2">


                                                    <div className='flex-grow-1 '>
                                                        <label>Pincode</label>


                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name='pin'
                                                            value={form.pin}
                                                            placeholder='Pincode'

                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>

                                                    <button className='btn btn-primary'
                                                        type="button"

                                                    >OK </button>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">State</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="state"
                                                    value={form.state}

                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">City</label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="city"
                                                    value={form.city}
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Region</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="region"
                                                    value={form.region}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Address</label>
                                                <textarea
                                                    className="form-control"
                                                    name="address"
                                                    placeholder="Enter here..."
                                                    value={form.address}

                                                    rows={4}
                                                    onChange={handleInputChange}
                                                />
                                            </div>


                                        </div>




                                        <div className="row">
                                            <h4 className='fw-semibold text-success mt-3'>Permanent Address</h4>
                                            <div className='col-md-4 '>



                                                <div className="d-flex align-items-end gap-2">


                                                    <div className='flex-grow-1 '>
                                                        <label>Pincode</label>


                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name='pincode_two'
                                                            value={form.pincode_two}
                                                            placeholder='Pincode'


                                                            required
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>

                                                    <button className='btn btn-primary'
                                                        type="button"

                                                    >OK </button>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">State</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="state_two"
                                                    value={form.state_two}
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">City</label>


                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="city_two"
                                                    value={form.city_two}
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Region</label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="region_two"
                                                    value={form.region_two}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-medium">Address</label>
                                                <textarea
                                                    className="form-control"
                                                    name="address_two"
                                                    placeholder="Enter here..."
                                                    value={form.address_two}

                                                    rows={4}
                                                    onChange={handleInputChange}
                                                />
                                            </div>


                                        </div>


                                        <div className="row">

                                        </div>


                                    </div>



                                    {/* Education and Experience */}
                                    <h5 className="mt-4 fs-4 text-center fw-semibold text-primary">Education & Experience</h5>
                                    <hr />
                                    <div className="row g-3">
                                        <div className="table-responsive my-4">

                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5>Experience</h5>

                                            </div>


                                            <Table bordered responsive className="text-center align-middle">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>Employer</th>
                                                        <th>Designation</th>
                                                        <th>DOJ</th>
                                                        <th>Left On</th>
                                                        <th>Joining Salary</th>
                                                        <th>Last Salary</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rows.length > 0 ? (
                                                        rows.map((row, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.employer}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.designation}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        value={row.doj}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        value={row.leftOn}

                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.joiningSalary}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.lastSalary}
                                                                        disabled
                                                                    />
                                                                </td>

                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-muted">
                                                                No rows added yet.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>

                                        </div>



                                        <div className="table-responsive my-4">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5>Education Details</h5>

                                            </div>

                                            <Table bordered responsive className="text-center align-middle">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>Exam</th>
                                                        <th>Board / University</th>
                                                        <th>Passing Year</th>
                                                        <th>Percentage</th>
                                                        <th>Certificate Upload</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {educationRows.length > 0 ? (
                                                        educationRows.map((row, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.exam}
                                                                        disabled
                                                                        placeholder="e.g. 10th / 12th / BSc"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={row.board}
                                                                        disabled
                                                                        placeholder="e.g. CBSE / Mumbai Univ."
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.passingYear}
                                                                        disabled
                                                                        placeholder="e.g. 2022"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={row.percentage}
                                                                        disabled
                                                                        placeholder="e.g. 85"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                                        disabled
                                                                    />



                                                                    {row.certificate && (
                                                                        <a
                                                                            href={`https://api.skyguard.group/uploads/${row.certificate}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            {row.certificate.split('/').pop()}
                                                                        </a>
                                                                    )}
                                                                </td>

                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="6" className="text-muted">
                                                                No education records added yet.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>

                                    </div>
                                    <div className='gap-2 d-flex justify-content-center mt-4'>
                                        <button type="submit" className='btn btn-success w-10'>
                                            {isEditMode ? "Update" : "Save"}
                                        </button>

                                        <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                            setShowForm(false);
                                            setForm({
                                                title: '', first: '', middle: '', last: '',
                                                emp_id: '', emp_code: '', phone: '', extension: '',
                                                email: '', dob: '', confirmed: '', gender: '', job_status: '',
                                                designation: '', department: '', address: '', city: '',
                                                pin: '', state: '', bank_name: '', bank_acc: '', bank_branch: '',
                                                ifsc: '', esic: '', reporting: '', weekly_off: '', basic: '',
                                                marital_status: '', doj: '', seperation_date: '', pf_no: '',
                                                role: '', region: '', alt_first: '', alt_second: '',
                                                lic: '', mediclaim_no: '', pincode_two: '', state_two: '', city_two: '', region_two: '', address_two: '',
                                            });
                                            setRows([]);
                                            setEducationRows([]);
                                        }}>
                                            Cancel
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    )}


                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th scope='col'>SN</th>
                                    <th scope='col'>Action</th>
                                    <th scope='col'>Full Name</th>

                                    <th scope='col'>Phone</th>
                                    <th scope='col'>Applied For</th>
                                    <th scope='col'>Status</th>
                                </tr>
                            </thead>
                            <tbody>



                                {filteredApplications.map((emp, idx) => {
                                    const fullName = `${emp.first} ${emp.middle} ${emp.last}`;

                                    const hasInterview = interviews.some(
                                        (item) => item.candidate_id == emp.id
                                    );

                                    const interviewForEmp = interviews.find(item => item.candidate_id === emp.id);

                                    return (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>

                                                <FaRegEye className='text text-dark me-2' size={20}
                                                    title='View Detail '
                                                    onClick={() => handleView(emp)} />

                                            {emp.active_status !== 'no' && (
    hasInterview ? (
        <LiaEdit
            className="text-primary mx-2"
            size={20}
            title="Edit Interview"
            onClick={() => {
                setSelectedEmp(emp);
                setIsEditMode(true);

                const fullName = [emp.first, emp.middle, emp.last]
                    .filter(Boolean)
                    .join(" ");

                const existing = interviews.find(
                    (item) => item.candidate_id == emp.id
                );

                if (existing) {
                    setInterviewForm({
                        ...existing,
                        candidate_name: fullName
                    });
                }

                setShowInterviewModal(true);
            }}
        />
    ) : (
        <FaLaptop
            size={20}
            className="text-warning me-2"
            title="Schedule Interview"
            onClick={() => {
                setSelectedEmp(emp);
                setIsEditMode(false);

                const fullName = [emp.first, emp.middle, emp.last]
                    .filter(Boolean)
                    .join(" ");

                setInterviewForm({
                    candidate_id: emp.id,
                    candidate_name: fullName,
                    interviewer: "",
                    step: "Step 1",
                    status: "Pending",
                    marks: "",
                    remarks: ""
                });

                setShowInterviewModal(true);
            }}
        />
    )
)}
                                
                                               {emp.active_status !== 'no' && (
                                              <BsPersonCheck size={20}
                                                    title="Make Employee"
                                                    className='text-success me-2'
                                                    onClick={() => {
                                                        setSelectedEmp(emp);
                                                        setShowMake(true);
                                                    }}
                                                />
                                               )}

                                       
                                           
                                                <GrStatusGood
                                                    size={22}
                                                    title='Change Status'
                                                    className='text-danger'
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        setSelectedEmp(emp);
                                                        setShowConfirm(true);
                                                    }}
                                                />
                                            </td>
                                            <td>{emp.first} {emp.middle} {emp.last}</td>
                                            <td>{emp.phone}</td>
                                            <td>{emp.role}</td>
                                            <td>
                                                {interviews
                                                    .filter(item => item.candidate_id == emp.id)
                                                    .sort((a, b) => b.id - a.id)[0]?.status || emp.status || "N/A"}
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>


            {showConfirm && selectedEmp && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{selectedEmp.active_status == 'no' ? 'Accept' : 'Reject'} this Application</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowConfirm(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    Are you sure you want to {selectedEmp.active_status == 'no' ? 'Shortlist' : 'Reject'} this candidate{" "}
                                    <strong>{selectedEmp.first} {selectedEmp.middle} {selectedEmp.last}</strong>?
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowConfirm(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        handleRejectEmployee(selectedEmp.id, selectedEmp.active_status == 'no' ? 'yes' : 'no');
                                        setShowConfirm(false);
                                        // setSelectedEmp(null);
                                    }}
                                >
                                    {selectedEmp.active_status == 'no' ? 'Accept' : 'Reject'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showMake && selectedEmp && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Joining</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowMake(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    Add <strong>{selectedEmp.first} {selectedEmp.middle} {selectedEmp.last}</strong> Candidate as Employee in SERP
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowMake(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        handleConfirmEmployee(selectedEmp.id);
                                        setShowMake(false);
                                        setSelectedEmp(null);
                                    }}
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {showInterviewModal && (
                <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content p-3">

                            <h5>Schedule Interview</h5>

                            {/* Candidate */}
                            <div className="mb-2">
                                <label>Candidate</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    // value={interviewForm.candidate_id}
                                    value={interviewForm.candidate_name || ""}
                                    readOnly
                                />
                            </div>

                            {/* Interviewer */}
                            <div className="mb-2">
                                <label>Interviewer</label>
                                <select
                                    className="form-control"
                                    name="interviewer"
                                    value={interviewForm.interviewer}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Employee</option>
                                    {user.map((emp, i) => (
                                        <option key={i} value={emp.id}>
                                            {emp.first} {emp.last}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Step */}
                            <div className="mb-2">
                                <label>Step</label>
                                <select
                                    className="form-control"
                                    name="step"
                                    // onChange={handleInterviewChange}
                                    value={interviewForm.step || "Step 1"}
                                    onChange={(e) => {
                                        setInterviewForm({
                                            ...interviewForm,
                                            step: e.target.value
                                        });
                                    }}
                                >
                                    <option>Step 1</option>
                                    <option>Step 2</option>
                                    <option>Step 3</option>
                                </select>
                            </div>

                            {/* Status */}
                            <div className="mb-2">
                                <label>Status</label>
                                <div className="d-flex">
                                    <select
                                        className="form-control"
                                        name="status"
                                        value={interviewForm.status || "Pending"}
                                        onChange={handleInterviewChange}
                                    >
                                        {statusOptions.map((status, i) => (
                                            <option key={i}>{status}</option>
                                        ))}
                                    </select>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-secondary mx-2"
                                        onClick={handleAddStatus}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>

                            {/* Marks */}
                            <div className="mb-2">
                                <label>Marks</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="marks"
                                    value={interviewForm.marks || ""}
                                    onChange={handleInterviewChange}
                                />
                            </div>

                            {/* Remarks */}
                            <div className="mb-2">
                                <label>Remarks</label>
                                <textarea
                                    className="form-control"
                                    name="remarks"
                                    rows={4}
                                    value={interviewForm.remarks || ""}
                                    onChange={handleInterviewChange}
                                />
                            </div>

                            {/* Buttons */}
                            <div className="text-end">
                                <button
                                    className="btn btn-secondary mx-2"
                                    onClick={() => {
                                        setShowInterviewModal(false);
                                        setInterviewForm({
                                            candidate_id: "",
                                            interviewer: "",
                                            candidate_name: "",
                                            step: "Step 1",
                                            status: "Pending",
                                            marks: "",
                                            remarks: ""
                                        });
                                    }}
                                >
                                    Close
                                </button>


                                <button
                                    className="btn btn-success"
                                    onClick={handleInterviewSubmit}
                                >
                                    {isEditMode ? "Update" : "Submit"}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

export default MyApplications